import { render } from "./WorksCited.vue?vue&type=template&id=9c1246fc&scoped=true"
import script from "./WorksCited.vue?vue&type=script&lang=js"
export * from "./WorksCited.vue?vue&type=script&lang=js"

import "./WorksCited.vue?vue&type=style&index=0&id=9c1246fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9c1246fc"

export default script